/** 优惠券类型 */
export var UICouponType;
(function (UICouponType) {
    /** 默认(带prize logo券) */
    UICouponType["default"] = "default";
    /** 现金券 */
    UICouponType["cash"] = "cash";
    /** 折扣券 */
    UICouponType["discount"] = "discount";
    /** 连锁券 */
    // chain = 'chain',
})(UICouponType || (UICouponType = {}));
/** 优惠券类型 */
var CouponType;
(function (CouponType) {
    /** 默认(带prize logo券) */
    CouponType["default"] = "default";
    /** 现金券 */
    CouponType["cash"] = "cash";
    /** 折扣券 */
    CouponType["discount"] = "discount";
    /** 连锁券 */
    // chain = 'chain',
})(CouponType || (CouponType = {}));
;
/** 优惠券按钮类型 */
export var CouponButtonType;
(function (CouponButtonType) {
    /** 默认 (按钮背景为主题色) */
    CouponButtonType["default"] = "default";
    /** 弱化 (按钮为白色，字为主题色) */
    CouponButtonType["weaken"] = "weaken";
    /** 置灰 */
    CouponButtonType["disabled"] = "disabled";
    /** 锁住 (带上锁图标) 注：V2删除 */
    CouponButtonType["lock"] = "lock";
})(CouponButtonType || (CouponButtonType = {}));
/** 标签类型 */
export var CouponTagColor;
(function (CouponTagColor) {
    /** 橙色 */
    CouponTagColor["orange"] = "orange";
    /** 红色 */
    CouponTagColor["red"] = "red";
})(CouponTagColor || (CouponTagColor = {}));
/** 主题色枚举 */
export var ThemeColor;
(function (ThemeColor) {
    /** 绿色 */
    ThemeColor["green"] = "green";
    /** 橙色 */
    ThemeColor["orange"] = "orange";
    /** 红色 */
    ThemeColor["red"] = "red";
    /** 白色 */
    ThemeColor["white"] = "white";
})(ThemeColor || (ThemeColor = {}));
/** 金额与折扣字号枚举 */
export var NumberFontSize;
(function (NumberFontSize) {
    /** 小号 */
    NumberFontSize["s"] = "s";
    /** 加小号 */
    NumberFontSize["xs"] = "xs";
})(NumberFontSize || (NumberFontSize = {}));
/** 优惠券提示条类型 */
export var CouponTipsType;
(function (CouponTipsType) {
    /** 手动 */
    CouponTipsType["manual"] = "manual";
    /** 连锁 */
    CouponTipsType["chain"] = "chain";
    /** 银行专属 */
    CouponTipsType["bank"] = "bank";
})(CouponTipsType || (CouponTipsType = {}));
